exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".holder[data-v-6a9f297a]{text-align:center;border:1px solid #ebebeb;border-radius:4px;padding:1em 0}.helper-text[data-v-6a9f297a]{text-align:center;display:block;padding:.5em 0;background-color:#ebebeb;color:darken(#ebebeb,2%);font-size:.875em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6a9f297a","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/Components/Elements/ImageZoom.vue
// module id = E9Ab
// module chunks = 0